import BaseApi from '@/core/api/baseApi'

export interface AiPromptRequest {
  prompt: string
}

export interface AiPromptResponse {
  content: string
}

export interface AiTranslationRequest {
  fields: Record<string, string | null>
  sourceLanguage: string
}

export interface AiTranslationResponse {
  translations: Record<string, Record<string, string | null>>
}

// Extended timeout for AI operations (60 seconds)
const AI_TIMEOUT = 60000

export default class AiApi extends BaseApi {
  async sendPrompt(data: AiPromptRequest, projectCode: string): Promise<AiPromptResponse> {
    return this.post<AiPromptResponse, AiPromptRequest>(
      `/api-admin/${projectCode}/ai/prompt`,
      data,
      { timeout: AI_TIMEOUT }
    )
  }

  async translateFields(data: AiTranslationRequest, projectCode: string): Promise<AiTranslationResponse> {
    return this.post<AiTranslationResponse, AiTranslationRequest>(
      `/api-admin/${projectCode}/ai/translations`,
      data,
      { timeout: AI_TIMEOUT }
    )
  }
}

export const aiApi = BaseApi.createApiInstance(AiApi)()
